import { MS_PER_MINUTE } from '../../../../../features/schedule/scheduleOverlap';
import { getScheduleLaidOutRowHeightPx } from '../../../../../features/schedule/scheduleZoomBounds';

export const GRID_SLOT_MINUTES = 5;

export function getMatchMinutesFromDayStart(startMs: number, dayStartMs: number): number {
  return (startMs - dayStartMs) / MS_PER_MINUTE;
}

/** Slot index for a grid-aligned time (valid starts are exact multiples of slot step). */
export function getScheduleSlotIndexFromDayStartMs(
  timeMs: number,
  dayStartMs: number,
  slotMinutes = GRID_SLOT_MINUTES,
  msPerMinute = MS_PER_MINUTE
): number {
  return (timeMs - dayStartMs) / (slotMinutes * msPerMinute);
}

/** Body Y offset in px; matches `--slot-height` / match `top` calc. */
export function getScheduleBodyYFromSlotIndex(slotIndex: number, scale: number): number {
  return slotIndex * getScheduleLaidOutRowHeightPx(scale);
}

export function getScheduleBodyYFromDayStartMs(
  timeMs: number,
  dayStartMs: number,
  scale: number,
  slotMinutes = GRID_SLOT_MINUTES,
  msPerMinute = MS_PER_MINUTE
): number {
  return getScheduleBodyYFromSlotIndex(
    getScheduleSlotIndexFromDayStartMs(timeMs, dayStartMs, slotMinutes, msPerMinute),
    scale
  );
}

export function getGridMatchTopCalc(minutesFromStart: number): string {
  const slotCount = minutesFromStart / GRID_SLOT_MINUTES;
  return `calc(var(--header-height) + ${slotCount} * var(--slot-height))`;
}

export function getGridMatchHeightCalc(durationMinutes: number): string {
  const slotCount = durationMinutes / GRID_SLOT_MINUTES;
  return `calc(${slotCount} * var(--slot-height))`;
}
